import { Middleware } from '@reduxjs/toolkit'

/**
 * Middleware para logging de actions (apenas em desenvolvimento)
 */
export const loggerMiddleware: Middleware = (store) => (next) => (action: unknown) => {
  if (process.env.NODE_ENV === 'development') {
    const actionType = typeof action === 'object' && action !== null && 'type' in action ? String(action.type) : ''
    console.group(actionType)
    console.info('dispatching', action)
    const result = next(action)
    console.log('next state', store.getState())
    console.groupEnd()
    return result
  }
  return next(action)
}

